module.exports = new __parcel__URL__("battleroyale_ready_up_button.b3b52ef0.png").toString();